import {ChatReducer, IChatState} from "../../../shared/chat/chat.reducer";

export const contractStateSelector = ['contracts', 'chat'];
export const contractDomainName = 'CONTRACTS';
export const {reducer: ContractChatReducer, sagas: contractCoreChatSaga, actions: ChatActions} = ChatReducer<IChatState>(contractDomainName, contractStateSelector);

